import { UserPlus, ClipboardList, MapPin, Clock, UserCheck } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Heading } from "@/components/design-system/Heading";
import { motion } from "framer-motion";

const benefits = [
  {
    icon: UserPlus,
    title: "Create your team profile",
    description: "Get started by creating your team's profile"
  },
  {
    icon: ClipboardList,
    title: "Post your match details",
    description: "Share all the important details about your match"
  },
  {
    icon: MapPin,
    title: "Set match location",
    description: "Specify where the match will take place"
  },
  {
    icon: Clock,
    title: "Wait for applications",
    description: "Goalkeepers will apply to your match"
  },
  {
    icon: UserCheck,
    title: "Choose your goalkeeper",
    description: "Select the perfect goalkeeper for your match"
  }
];

export const TeamBenefits = () => {
  return (
    <div>
      <Heading level="h2" className="text-2xl font-bold mb-6 text-center">
        For Teams ⚽
      </Heading>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {benefits.map((benefit, index) => (
          <motion.div
            key={benefit.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className="h-full"
          >
            <Card className="p-6 h-full bg-white/60 backdrop-blur border-2 border-primary/10 hover:border-primary/20 transition-all duration-300 flex flex-col">
              <div className="mb-4 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <benefit.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-gray-600 flex-grow">{benefit.description}</p>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};